/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllPartyQueryVariables = {||};
export type AllPartyQueryResponse = {|
  +allParties: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +partyName: string,
        +partyImage: ?string,
        +priceDiffPercentage: ?number,
      |}
    |}>
  |}
|};
export type AllPartyQuery = {|
  variables: AllPartyQueryVariables,
  response: AllPartyQueryResponse,
|};
*/


/*
query AllPartyQuery {
  allParties {
    edges {
      node {
        id
        partyName
        partyImage
        priceDiffPercentage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PartyNodeConnection",
    "kind": "LinkedField",
    "name": "allParties",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PartyNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PartyNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partyName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partyImage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priceDiffPercentage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllPartyQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllPartyQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1143595ec3a18f04559c1196cf600bbb",
    "id": null,
    "metadata": {},
    "name": "AllPartyQuery",
    "operationKind": "query",
    "text": "query AllPartyQuery {\n  allParties {\n    edges {\n      node {\n        id\n        partyName\n        partyImage\n        priceDiffPercentage\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a05a58be909b614892947a2dec1ea12a';

module.exports = node;
